import { useIntl } from '@capsicum/common';
import { TextInput } from '@capsicum/common-web';
import { useAmlSourceOfIncomeEstimate } from '@capsicum/features/regulations/shared';
import { FormProvider } from 'react-hook-form';

import * as S from './AmlQuestionnaire.styled';

export const SourceOfIncomeEstimate = () => {
	const { $t } = useIntl();
	const { sourceOfIncomeEstimateForm } = useAmlSourceOfIncomeEstimate();

	return (
		<S.Wrapper>
			<FormProvider {...sourceOfIncomeEstimateForm}>
				<S.Question>{$t('amlQuestionnaire.sourceOfIncomeEstimateStep.question')}</S.Question>
				<TextInput
					autoCapitalize="none"
					label={$t('amlQuestionnaire.sourceOfIncomeEstimateStep.label')}
					name="estimatedAnnualIncome"
					placeholder={$t('amlQuestionnaire.thirdStep.placeholder')}
					testID="aml-questionnaire-source-of-income-estimate-amount-input"
					type="number"
				/>
			</FormProvider>
		</S.Wrapper>
	);
};
